import { formatPhone } from "shared/utils/format-phone";

// A call the partner's own AI leasing agent handed to a human (CRM-1393).
// boompay-api resolves the person on the line into the call's external number
// and names the agent line they reached first in `transferred_from_number` /
// `transferred_from_name`. Every surface — the incoming popup, the in-call
// card, the Calls screen — reads these helpers so they can never disagree
// about the same hand-off.

export const UNKNOWN_CALLER_LABEL = "Unknown caller";

/**
 * When the api could not tell who the agent was talking to, the external
 * number IS the agent line: nobody's number. It must never be shown as the
 * caller, saved on a lead, or dialed back (that would ring the AI agent).
 */
export const isCallerUnknown = (
  externalNumber: string | null | undefined,
  transferredFromNumber: string | null | undefined
): boolean =>
  !!transferredFromNumber && transferredFromNumber === externalNumber;

/**
 * "Ludington MI AI agent", or for an unlabelled line "AI agent (555) 524-0000".
 * A teammate who transferred the call to you (CRM-1747) is named instead:
 * "Faye Lee". Null for a direct call.
 */
export const transferSourceLabel = (
  transferredFromNumber: string | null | undefined,
  transferredFromName: string | null | undefined,
  transferredByName?: string | null
): string | null => {
  const teammate = transferredByName?.trim();
  if (teammate) return teammate;
  if (!transferredFromNumber) return null;
  const name = transferredFromName?.trim();
  return name
    ? `${name} AI agent`
    : `AI agent ${formatPhone(transferredFromNumber)}`;
};
